import { DateTime } from "luxon";
import React from "react";
import { SanityNode } from "../../config/build/models/node";
import useTranslations from "../../hooks/useTranslations";
import { CalendarEvent } from "../../models/calendar/CalendarEvent";
import { isNullOrWhiteSpace } from "../../shared/string";
import LinkWithArrow from "../LinkWithArrow";

interface Props {
  archiveLinkReference?: SanityNode;
  events: CalendarEvent[];
  title?: string;
}

const CalendarCard = ({ title, events, archiveLinkReference }: Props) => {
  const translations = useTranslations();

  return (
    <div className="flex flex-col p-6 bg-brand-primary-90 border border-brand-primary-90 shadow-lg rounded">
      {!isNullOrWhiteSpace(title) && (
        <>
          <h2 className="text-brand-primary-20">{title}</h2>
          <hr className="border-brand-primary-dim-80 mt-4 mb-3" />
        </>
      )}
      <ul className="flex flex-col items-start text-xl font-bold">
        {events.map((event, index: number) => (
          <li
            key={index}
            className="flex flex-col items-start w-full border-b border-brand-primary-dim-80 pb-5 mb-3"
          >
            <h4 className="text-subheader-primary uppercase text-base mt-2 font-bold">
              {!!event.startDate?.length && (
                <span
                  className={`inline-block pr-2 mr-2 whitespace-nowrap ${
                    event.endDate?.length ? "border-r border-brand-primary-dim-70" : ""
                  }`}
                >
                  {DateTime.fromISO(event.startDate)
                    .toLocaleString(DateTime.DATETIME_MED)
                    .replace(/[,.]|/g, "")
                    .replace("24:", "00:")}
                </span>
              )}

              {!!event.endDate?.length && (
                <span className="inline-block whitespace-nowrap">
                  {DateTime.fromISO(event.endDate)
                    .toLocaleString(DateTime.DATETIME_MED)
                    .replace(/[,.]/g, "")
                    .replace("24:", "00:")}
                </span>
              )}
            </h4>
            <h3 className="text-xl">{event.title}</h3>
            {/* TODO: Implement calendar card button */}
            {/* <Button 
                            className="mt-2"
                            color="primary-dim"
                            size={ButtonSize.Small30}>
                            Add to calendar
                        </Button> */}
          </li>
        ))}
      </ul>
      <div className="flex flex-grow items-end justify-end mt-8">
        <LinkWithArrow
          linkInfo={{
            reference: archiveLinkReference,
            title: translations.allCalendarEvents ?? undefined
          }}
        />
      </div>
    </div>
  );
};

export default CalendarCard;
